import { render, staticRenderFns } from "./RoleListTable.vue?vue&type=template&id=f35cc0ec&scoped=true"
import script from "./RoleListTable.vue?vue&type=script&lang=js"
export * from "./RoleListTable.vue?vue&type=script&lang=js"
import style0 from "./RoleListTable.vue?vue&type=style&index=0&id=f35cc0ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35cc0ec",
  null
  
)

export default component.exports